import React from "react";

// Types
import Question from "../../types/Question";

// Styles
import "../../components/Inputs/Input.scss";
import "./Entry.scss";

// Contexts
import { useSettings } from "../../contexts/SettingsContext";

// Utils/config
import { withTranslation } from "react-i18next";

// Services
import AuthService from "../../services/AuthService";

// Components
import { IonButton, IonCol, IonContent, IonImg, IonLoading, IonNote, IonRouterLink, IonRow } from "@ionic/react";
import Button from "../../components/Button/Button";
import InputFactory from "../../components/Factories/Input/InputFactory";
import BasicTemplate from "../../components/PageTemplates/BasicTemplate";
import AccountBlocked from "./AccountBlocked/AccountBlocked";
import ResetPassword from "./ResetPassword/ResetPassword";

// Styles
import { debug } from "../../App";
import "../../components/Inputs/Input.scss";
import "./Entry.scss";

class Login extends React.Component<any, any> {
  constructor(props: any, context: any) {
    super(props, context);
    this.state = {
      formData: {},
      errors: {},
      message: null,
      loading: false,
      isMobile: window.innerWidth < 992,
      resetPasswordIsOpen: false,
      accountBlockedIsOpen: false,
    };
  }

  componentDidMount(): any {
    window.addEventListener("resize", () => this.setState({ isMobile: window.innerWidth < 992 }));
    return window.removeEventListener("resize", () => this.setState({ isMobile: window.innerWidth < 992 }));
  }

  render() {
    const { accountBlockedIsOpen, resetPasswordIsOpen } = this.state;
    const path = window.location.pathname;
    const { t, settings } = this.props;

    return (
      <BasicTemplate hideNavigation={true} hideHeader={true}>
        <IonLoading isOpen={this.state.loading} message={t("loggingYouIn")} />
        <IonContent>
          <div className="entry entry--login">
            {/*<IonHeader className={"entry__header ion-no-border"}>
              <IonRow>
                <IonCol size="4">
                  <img
                    alt={`${t("instance")} logo`}
                    className="entry__logo"
                    src={!this.state.isMobile ? (settings?.brand?.img_path_admin_header_logo || "assets/logo-white.svg") : (settings?.brand?.img_path_app_header_logo || "assets/logo-white-icon.svg")}
                  />
                </IonCol>
              </IonRow>
            </IonHeader>*/}
            {this.state.isMobile && (
              <div
                style={{
                  minHeight: "30vh",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <IonImg
                  src={settings?.brand?.img_path_login_screen_logo}
                  style={{
                    maxWidth: "240px",
                  }}
                />
              </div>
            )}
            <form className="wrapper" onKeyPress={this.handleKeyPress}>
              <IonRow className="entry__panels">
                <IonCol sizeXs="12" sizeSm="12" sizeMd="12" sizeLg="6" className="entry__panel entry__panel--left">
                  <h1 className="entry__panel__heading">{t("memberZone")}</h1>
                  <div className="ion-margin-vertical">
                    {this.renderInput({
                      name: "Email address",
                      key: "email",
                      type: "email",
                      rules: ["required"],
                    })}
                  </div>
                  <div className="ion-margin-vertical">
                    {this.renderInput({
                      name: "Password",
                      key: "password",
                      type: "password",
                      rules: ["required"],
                    })}
                  </div>
                  <IonRow className="entry__buttons">
                    <IonCol size="6">
                      <Button text={t("signIn")} onClick={this.handleLogin} className="button--entry" />
                    </IonCol>

                    <IonCol size="6">
                      <Button
                        text={t("resetPassword")}
                        color={"light"}
                        onClick={() => {
                          this.setState({ resetPasswordIsOpen: true });
                        }}
                      ></Button>
                    </IonCol>
                  </IonRow>
                  {/* <IonRow className="entry__forgot-password">
                    <IonCol>
                      <button onClick={this.openForgotPasswordModal.bind(this)}>{t("forgottenPassword")}</button>
                    </IonCol>
                  </IonRow> */}
                </IonCol>
                <IonCol sizeXs="12" sizeSm="12" sizeMd="12" sizeLg="6" className="entry__panel entry__panel--right">
                  {path === "/admin" ? (
                    <img alt={`${t("instance")} logo`} width="185" src={"assets/logo-white-vertical.svg"} />
                  ) : (
                    <div className="entry__register">
                      <IonNote className={"entry__register-txt"}>{t("dontHaveAccount")}</IonNote>
                      <IonRouterLink routerLink={"/register"}>
                        <IonButton fill={"outline"}>Register</IonButton>
                      </IonRouterLink>
                    </div>
                  )}
                </IonCol>
              </IonRow>
            </form>
          </div>
        </IonContent>
        {/* @ts-ignore */}
        <ResetPassword isOpen={resetPasswordIsOpen} closeModal={() => this.setState({ resetPasswordIsOpen: false })} />
        {/* @ts-ignore */}
        <AccountBlocked isOpen={accountBlockedIsOpen} closeModal={() => this.setState({ accountBlockedIsOpen: false })} />
      </BasicTemplate>
    );
  }

  openForgotPasswordModal(event: any) {
    event.preventDefault();
    this.setState({ resetPasswordIsOpen: true });
  }

  renderInput(question: Question) {
    const rules: string[] = Object.values(question.rules || []);
    const { formData, errors } = this.state;

    return (
      <div className={`input__container input__container--type-${question.type} ${errors[question.key] && "has-error"}`}>
        <InputFactory
          className={"input__input input-factory__input input-factory__input--type-" + question.type}
          type={question.type}
          name={question.key}
          value={formData[question.key]}
          options={question.options}
          optionsFrom={question.optionsFrom}
          onIonChange={this.handleChange}
          placeholder={`${question.name} ${rules.includes("required") ? " *" : ""}`}
          rules={question.rules}
        />
        <IonNote color="danger">{errors && errors[question.key]}</IonNote>
      </div>
    );
  }

  handleChange = (e: any) => {
    const { formData } = this.state;

    if (e.detail.value !== undefined) {
      formData[e.target.name] = e.detail.value;
    } else {
      delete formData[e.detail.name];
    }

    this.setState({ formData });
  };

  handleKeyPress = (event: any) => {
    if (event.key === "Enter") {
      this.handleLogin(event);
    }
  };

  handleLogin = (event: any) => {
    event.preventDefault();
    const { t } = this.props;
    this.setState({ loading: true });

    AuthService.login(this.state.formData["email"], this.state.formData["password"])
      .then((user: any) => {
        debug("Login.handleLogin: user = ", user);
        this.setState({ loading: false });
        this.props.history.push("/");
      })
      .catch((err) => {
        this.setState({
          accountBlockedIsOpen: err.code === 403,
          message: err.message !== t("givenDataInvalid") ? err.message : null,
          errors: err.errors || { email: err.code === 403 ? t("accountBlocked") : null, password: null },
        });

        this.setState({ loading: false });
      });
  };
}

function withSettings(Component: any) {
  return function WithSettings(props: any) {
    const { settings } = useSettings();
    return <Component {...props} settings={settings} />;
  };
}

// @ts-ignore
export default withTranslation()(withSettings(Login));
